import { useEffect, useState } from "react";
import { loadAuthUser, getAuthUserSync } from "./api";

// Shared, single-fetch auth state. Returns the logged-in user (or null) and a
// loading flag. Backed by the module-level cache in api.js so multiple
// components don't each hit /auth/me.
export function useAuthUser() {
  const cached = getAuthUserSync();
  const [user, setUser] = useState(cached ?? null);
  const [loading, setLoading] = useState(cached === undefined);

  useEffect(() => {
    let mounted = true;
    loadAuthUser().then((u) => {
      if (mounted) {
        setUser(u);
        setLoading(false);
      }
    });
    return () => {
      mounted = false;
    };
  }, []);

  return { user, loading };
}
